import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { GlassMagnifier } from "react-image-magnifiers";

// Types
import { type Swiper as SwiperTypes } from "swiper";

function ProductImages({ productImages, offerBadge }: any) {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperTypes | null>(null);
  const [isClient, setisClient] = useState(false);

  useEffect(() => {
    setisClient(true);
    // Preload all product images for better performance
    productImages?.forEach((url: string) => {
      const link = document.createElement("link");
      link.rel = "preload";
      link.href = url;
      link.as = "image";
      link.fetchPriority = "high";
      document.head.appendChild(link);
    });
  }, [productImages]);

  return (
    <Box className="ProductImages">
      <Box className="SwiperContainer">
        <Swiper
          className="MainThumbnail"
          thumbs={{ swiper: thumbsSwiper }}
          modules={[FreeMode, Thumbs]}
          spaceBetween={10}
          allowTouchMove={false}
        >
          {productImages?.length > 0
            ? productImages.map((url: any, index: number) => (
              <SwiperSlide key={url}>
                <Stack className="ImageWrapper">
                  <Box className="Image">
                    <GlassMagnifier
                      imageSrc={(url ? url.split("?")[0] : null)}
                      imageAlt="Product image"
                      className="Magnifier"
                      magnifierSize="50%"
                      square
                    />
                    {offerBadge}
                    {index === 0 && (
                      <img
                        src={(url ? url.split("?")[0] : null)}
                        alt="LCP image"
                        rel="preload"
                        // fetchPriority="high"
                        style={{ display: "none" }} // Ensures fetchpriority takes effect without visual duplication
                      />
                    )}
                  </Box>
                </Stack>
              </SwiperSlide>
            ))
            : null}
        </Swiper>
        {isClient && (
          <Swiper
            className="SupportImages"
            onSwiper={setThumbsSwiper}
            modules={[FreeMode, Navigation, Thumbs]}
            spaceBetween={10}
            slidesPerView={4}
            freeMode
            watchSlidesProgress
            breakpoints={{
              425: { slidesPerView: 5 },
              500: { slidesPerView: 6 },
              600: { slidesPerView: 7 },
              700: { slidesPerView: 8 },
              800: { slidesPerView: 9 },
              900: { slidesPerView: 5 },
              1200: { slidesPerView: 7 },
              1440: { slidesPerView: 8 },
            }}
          >
            {productImages?.length > 0
              ? productImages?.map((url: any) => (
                <SwiperSlide key={url}>
                  <img src={(url ? url.split("?")[0] : null)} alt="Thumbnail" />
                </SwiperSlide>
              ))
              : null}
          </Swiper>
        )}
      </Box>
    </Box>
  );
}

export default ProductImages;
